import { Component, OnInit, ViewChild, TemplateRef, ViewEncapsulation, Output, EventEmitter} from '@angular/core';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { ExecutorSearch } from 'src/app/_models/search-ejecutor-filtro.model';
import { CatalogoModel, BinManagerParams } from 'src/app/_models/bin-catalogos.model';
import { BlockDeleteBin } from 'src/app/_models/block-delete-model';
import { BinesSeachResponse } from 'src/app/_models/bin-seach-result';
import { ZeroService } from 'src/app/_services/zero/zero.service';
import { REST_SERVICES } from 'src/app/_services/settings';
import { Router, NavigationExtras } from '@angular/router';
import { Globals } from 'src/app/_services/zero/globals';
import { MzModalService, MzToastService } from 'ngx-materialize';
import { AuthenticationService } from '../../_services/authentification.service';
import { Role } from '../../_models/oauth.models'
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ModalsComponent } from 'src/app/semantic/modals/modals.component';
import { CamposService } from '../../_services/campos.service';
import { EMPTY } from 'rxjs';
import { Page } from 'src/app/_models/page.model';
import { debug } from 'util';
import { ReporteRequest } from 'src/app/_models/reportes.model';
import * as FileSaver from 'file-saver';
import { BinesSeachElimResponse } from 'src/app/_models/bin-seach-result-elim';
import { ControlSearchAltaResponse } from 'src/app/_models/control-search-alta-model';
import { InfoBinesPendientesModel } from "src/app/_models/bin-catalogos.model";

@Component({
  selector: "app-search-ejecutor",
  templateUrl: "./search-ejecutor.component.html",
  styleUrls: ["./search-ejecutor.component.css"],
  host: ROUTE_ANIMATION_HOST,
  animations: [ROUTE_ANIMATION],
  encapsulation: ViewEncapsulation.None,
})
export class SearchEjecutorComponent implements OnInit {
  public filtros: ExecutorSearch;
  public options: Pickadate.DateOptions;
  public institucion: Array<CatalogoModel>;
  public tipoBin: Array<CatalogoModel>;
  public tipoBinReportes: Array<CatalogoModel>;
  public tipoBinesLatam: Array<CatalogoModel>;
  public tipoBinesEspeciales: Array<CatalogoModel>;
  public accion: Array<CatalogoModel>;
  public estatus: Array<CatalogoModel>;
  public binFiltroParams: BinManagerParams;
  public activo: string = "false";
  public cellTem: any;
  public rol: Role;
  public blockBin: BlockDeleteBin;
  public datePipe: DatePipe;
  public page: Page;
  public isTableHidden: boolean;
  public isTableHiddenAux: boolean;
  public control: ControlSearchAltaResponse;
  // Datatable componentes
  public rowsDataTables: Array<BinesSeachResponse> = [];
  public rowsDataTablesElim: Array<BinesSeachElimResponse> = [];
  public columnsDataTable: Array<any> = [];
  public columnsDataTableDelete: Array<any> = [];
  public checkBin: Boolean = false;
  public ruta: string;
  public navigationExtras: NavigationExtras;
  // Reportes
  public filtrosRep: ReporteRequest;
  public marca: Array<CatalogoModel>;
  public grupoSelect: number = null;
  public isGrupo: number = 0;
  public titleToGroup: string;
  
  
  // Templates datatable columns
  @ViewChild("columSwitchTemplate") public columSwitchTemplate: TemplateRef<any>;
  @ViewChild("columButtomCheck") public columButtomCheck: TemplateRef<any>;
  @ViewChild("buttomTemplateOptionsBinManeger")  public buttomTemplateOptionsBinManeger: TemplateRef<any>;
  @ViewChild("columButtomSearch") public columButtomSearch: TemplateRef<any>;
  @ViewChild("columButtomTemplateOptions") public columButtomTemplateOptions: TemplateRef<any>;
  @ViewChild("columProc") public columProc: TemplateRef<any>;
  @ViewChild("columIns") public columIns: TemplateRef<any>;

  public onEventTemplate: EventEmitter<Object>;

  public messages = {
    // Message to show when array is presented
    // but contains no values
    emptyMessage: "No hay información para mostrar",

    // Footer total message
    totalMessage: "total",
  };

  public enableExportar: boolean;
  public pieChartLabels: string[] = ['DE 1 A 5 DÍAS', 'DE 6 A 20 DÍAS', 'MAS DE 21 DÍAS'];
  public pieChartDataBinPendientes: number[] = [0, 0, 0];
  public seriesBinPendientes = [];
  chartVisible: boolean = false; 
  public pieChartType: string = 'doughnut';
  public chartColors: Array<any> = [
    { // first color
      backgroundColor: ['#95C11F', '#DEDC00', '#E32D09']
    }];

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }


  /*
   * Constructor
   */
  constructor(
    private router: Router,
    private zeroService: ZeroService,
    private globals: Globals,
    private authenticationService: AuthenticationService,
    private modalService: MzModalService,
    private toast: ToastrService,
    private obsCampos: CamposService
  ) {
    this.options = globals.optionsByPickerdate;
    this.filtros = new ExecutorSearch();
    this.binFiltroParams = new BinManagerParams();
    this.institucion = new Array<CatalogoModel>();
    this.tipoBin = new Array<CatalogoModel>();
    this.tipoBinReportes = new Array<CatalogoModel>();
    this.tipoBinesLatam = new Array<CatalogoModel>();
    this.tipoBinesEspeciales = new Array<CatalogoModel>();
    this.accion = new Array<CatalogoModel>();
    this.estatus = new Array<CatalogoModel>();
    this.blockBin = new BlockDeleteBin();
    this.datePipe = new DatePipe("es-Mx");
    this.page = new Page();
    this.onEventTemplate = new EventEmitter();
    this.filtrosRep = new ReporteRequest();
    this.marca = new Array<CatalogoModel>();
    this.titleToGroup = "BIN: ";
    this.isTableHidden = false;
    this.isTableHiddenAux = true;
    this.control = new ControlSearchAltaResponse();
    this.enableExportar = false;
  }

  ngOnInit() {
    this.pieChartDataBinPendientes = [];
    this.rol = this.authenticationService.currentUserValue.role;
    this.ruta = this.router.url.substring(1, 16);
    this.filtros.tipoBin = "0";
    if (this.ruta == "checkSupervisor") {
      this.checkBin = true;
      //this.buscarBinCifrasControl();
    }
    this.buscarBin();
    this.buscarInstituciones();
    this.buscarTipoBin();
    this.buscarTipoBinReporte();
    this.buscarTipoBinesLatam();
    this.buscarTipoBinesEspeciales();
    this.buscarEstatus();
    this.buscarAccion();
    this.validaRol();
    this.buscarMarcaProducto();
	  this.isTableHidden = false;
    this.isTableHiddenAux = true;
	this.columnsDataTableDelete = [
      { name: "BIN", prop: "bin" },
      { name: "USUARIO ALTA", prop: "usuario_alta" },
      { name: "USUARIO MOD", prop: "usuario_mod" },
      { name: "USUARIO AUTORIZADOR", prop: "usuario_autorizador" },
      { name: "FECHA ALTA", prop: "fch_alta" },
      { name: "FECHA MOD", prop: "fch_mod" },
      { name: "FECHA AUTORIZACION", prop: "fch_autorizacion"},
      { name: "ID TIPO BIN", prop: "id_tipo_bin_fk"},
      { name: "ID INSTITUCION", prop: "id_institucion_fk"}
    ];
  }

  pieChartLabelBinPendientes(seriesExtractos: any[], name: string): string {
    const item = seriesExtractos.filter(data => data.name === name);
    if (item.length > 0) {
      return item[0].label;
    }
    return name;
  }

  // Convert DataSet to PieChart
  private convertDatasetPieChart(binesPendientes: Array<InfoBinesPendientesModel>) {
    let sumTotalRed: number = 0;
    let sumTotalGreen: number = 0;
    let sumTotalYelow: number = 0;
    binesPendientes.forEach((element: any) => {
      if(element.idIndicador == 1) {
        sumTotalGreen += element.total;
      } else if(element.idIndicador == 2) {
        sumTotalYelow += element.total;
      } else if(element.idIndicador == 3) {
        sumTotalRed += element.total;
      }
    });
    
      this.seriesBinPendientes = [
        {
          name: "DE 1 A 5 DÍAS",
          value: sumTotalGreen
        },
        {
          name: "DE 6 A 20 DÍAS",
          value: sumTotalYelow
        },
        {
          name: "MAS DE 21 DÍAS",
          value: sumTotalRed
        } 
        ];
      this.chartVisible = this.seriesBinPendientes.some(data => data.value > 0);
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset + 1;
    if(this.grupoSelect) {
      this.detalleGrupo(this.grupoSelect);
    } else {
     
      if(this.filtros != null && this.filtros.idEstadoBin != null && this.filtros.idEstadoBin==6){
        this.buscarBinElim();
      }else{
        this.buscarBin();
      }
    }
  }

  buscarBinFiltros() {
    this.page.pageNumber = 1;
    if(this.filtros != null && this.filtros.idEstadoBin != null && this.filtros.idEstadoBin==6){
      this.buscarBinElim();
    }else{
      this.buscarBin();
    }
    
  }

  onclickTemplate(target, rowData, accion) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion,
    });
  }

  limpiar() {
    this.filtros = new ExecutorSearch();
  }

  eliminaSeleccionFiltros() {
    if(this.filtros.idEstadoBin==6){
    this.filtros.bin = null;
    this.filtros.idBanco = null;
    this.filtros.idTipoBin = null;
    this.filtros.fechaFin = null;
    this.filtros.fechaInicio =null;
    this.filtros.idAccion = null;
    //this.filtros.idGrupo = null;
    //this.filtros.idProcesador = null;
    this.isTableHidden = true;
    this.isTableHiddenAux = false;
    }else{
      this.isTableHidden = false;
      this.isTableHiddenAux = true;
    }
    
  }

  validaRol() {

    if (Role.Prevencion == this.rol) {
      this.onEventTemplate.subscribe((selected) => {
        this.validaAccion(
          selected.rowSelect,
          selected.targetSelect,
          selected.accion
        );
      });
      this.columnsDataTable = [
        { name: "BIN", prop: "bin" },
        { name: "NOMBRE INSTITUCIÓN", prop: "nombreInstitucion", width: 210 },
        { name: "PROCESADOR", prop: "dscProcesador", width: 165 },
        { name: "ESTATUS", prop: "estatus" },
        { name: "SECTOR BM", prop: "sectorBm" },
        { name: "NÚMERO BM", prop: "numeroBm", width: 155 },
        { name: "INSTITUCIÓN BM", prop: "nombreBm", width: 180 },
        { name: "FECHA ALTA", prop: "fechaAlta", width: 170 },
        // { name: "FECHA MODIFICACIÓN", prop: "fechaMod", width: 210 },
        { name: "USUARIO MOD", prop: "userMod", width: 220 },
        {
          name: "BLOQUEAR/DESBLOQUEAR",
          cellTemplate: this.columSwitchTemplate,
          width: 240,
        },
        { name: "CONSULTAR", cellTemplate: this.columButtomCheck, width: 160 },
      ];
    }
    if (Role.Ejecutor == this.rol) {
      this.onEventTemplate.subscribe((selected) => {
        this.validaAccion(
          selected.rowSelect,
          selected.targetSelect,
          selected.accion
        );
      });
      this.columnsDataTable = [
        { name: "BIN", prop: "bin" },
        { name: "NOMBRE INSTITUCIÓN", prop: "nombreInstitucion", width: 210 },
        { name: "PROCESADOR", prop: "dscProcesador", width: 160 },
        { name: "ESTATUS", prop: "estatus" },
        { name: "SECTOR BM", prop: "sectorBm" },
        { name: "NÚMERO BM", prop: "numeroBm", width: 155 },
        { name: "INSTITUCIÓN BM", prop: "nombreBm", width: 178 },
        { name: "FECHA ALTA", prop: "fechaAlta" },
        { name: "FECHA MOD", prop: "fechaMod", width: 170 },
        { name: "USUARIO MOD", prop: "userMod", width: 180 },
        {
          name: "OPCIONES",
          cellTemplate: this.columButtomTemplateOptions,
          width: 240,
        },
      ];
    }
    if (Role.Supervisor == this.rol) {
      this.onEventTemplate.subscribe((selected) => {
        this.validaAccion(
          selected.rowSelect,
          selected.targetSelect,
          selected.accion
        );
      });
      this.columnsDataTable = [
        { name: "BIN", prop: "bin" },
        { name: "NOMBRE INSTITUCIÓN", prop: "nombreInstitucion", width: 210 },
        { name: "PROCESADOR", prop: "dscProcesador", width: 160 },
        { name: "ESTATUS", prop: "estatus" },
        { name: "SECTOR BM", prop: "sectorBm" },
        { name: "NÚMERO BM", prop: "numeroBm", width: 155 },
        { name: "INSTITUCIÓN BM", prop: "nombreBm", width: 178 },
        { name: "FECHA ALTA", prop: "fechaAlta" },
        { name: "FECHA MOD", prop: "fechaMod"},
        { name: "USUARIO MOD", prop: "userMod"},
        { name: "ACCIÓN", prop: "accion", width: 160 },
        { name: "REVISAR", cellTemplate: this.columButtomSearch, width: 180},
      ];
    }
  }

  validaAccion(rowSelect: any, targetSelect: any, accion: any) {
    if (accion == "delete") {
      this.validaSuspencionOEliminacion(rowSelect);
    }
    if (accion == "edit") {
      // Datos extra enviados por route
      this.obsCampos.obs.next(EMPTY);
      this.binFiltroParams.bin = rowSelect.bin;
      this.binFiltroParams.idBin = rowSelect.id;
      this.binFiltroParams.idTipoBin = rowSelect.idTipo;
      this.binFiltroParams.idInstitucion = rowSelect.idInstitucion;
      this.binFiltroParams.url = this.router.url;
      this.binFiltroParams.binManagerAdqiEmisor = rowSelect;
      this.binFiltroParams.origenInfo = rowSelect.origen;
      this.binFiltroParams.idGrupo = this.grupoSelect;

      this.obsCampos.obs.next(this.binFiltroParams);
      if (rowSelect.idTipo != 4 && rowSelect.idTipo != 8 && rowSelect.isGrupo == 0) {
        this.router.navigate(["/binesAbc", rowSelect.id, "I"], {
          queryParams: { refresh: new Date().getTime() },
        });
      } else if(rowSelect.isGrupo == 1){
        this.router.navigate(["/binesAbc", rowSelect.id, "G"], {
          queryParams: { refresh: new Date().getTime() },
        });
      }

    }
    if (accion == "revisar") {

      if(rowSelect.isGrupo == 0){
        this.router.navigate(["/detalleBinPrev", rowSelect.id, true, "I"], {
          queryParams: {
            origenInfo: rowSelect.origen,
            refresh: new Date().getTime() },
        });
      } else if(rowSelect.isGrupo == 1){
        this.router.navigate(["/detalleBinPrev", rowSelect.id, true, "G"], {
          queryParams: {
            origenInfo: rowSelect.origen,
            refresh: new Date().getTime() },
        });
      }


    }
    if (accion == "consultar") {
      let rechazado: boolean;
      rechazado = rowSelect.idEstatus == 4 ? false : false;

      // Datos extra enviados por route
      if (this.checkBin) {
        this.navigationExtras = {
          queryParams: {
            idEstatus: rowSelect.idEstatus,
            checkBin: this.checkBin,
            accion: rowSelect.accion.toLowerCase(),
            origenInfo: rowSelect.origen,
            idGrupo: this.grupoSelect
          },
        };
      } else {
        this.navigationExtras = {
          queryParams: {
            idEstatus: rowSelect.idEstatus,
            checkBin: this.checkBin,
            origenInfo: rowSelect.origen
          },
        };
      }
      if(rowSelect.isGrupo == 0){
        this.router.navigate(
          ["/detalleBin", rowSelect.id, true, rechazado, "I"],
          this.navigationExtras
        );
      } else if(rowSelect.isGrupo == 1){
        this.router.navigate(
          ["/detalleBin", rowSelect.id, true, rechazado, "G"],
          this.navigationExtras
        );
      }
    }

    if (accion == "comment") {
      this.verComentario(rowSelect.id);
    }

    if (accion == "depurar") {
      this.depurarBin(rowSelect);
    }

    if (accion == "detalleGrupo") {
      this.page.pageNumber = 1;
      this.detalleGrupo(rowSelect.idGrupo);
    }
  }

  verComentario(idBin: number) {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSCAR_COMENTARIO + idBin,
      method: "GET",
      showInfo: true,
      ok: (response) => {
        if (response.responsecode == "0" && response.response) {
          this.modalService.open(ModalsComponent, {
            modal_title: "COMENTARIO",
            modal_body: response.response,
            isComents: false,
          });
        } else {
          this.toast.warning(
            "<h5>Mensaje de sistema...</h5> <span>No existen comentarios</span>",
            "",
            { closeButton: false, enableHtml: true, disableTimeOut: false }
          );
        }
      },
    });
  }

  validaSuspencionOEliminacion(rowSelect: any) {
    let mensaje = "";
    let url = "";
    this.isGrupo = rowSelect.isGrupo;
    if (rowSelect.idEstatus == 1) {
      mensaje = "¿Está seguro de suspender el registro?";
      url = REST_SERVICES.SUSPENDER_BIN;
      this.modalComentarioEliminar(rowSelect.id, mensaje, url);
    } else if (rowSelect.idEstatus == 3 || rowSelect.idEstatus == 4) {
      mensaje = "¿Está seguro de eliminar el registro?";
      url = REST_SERVICES.ELIMINAR_BIN;
      this.modalComentarioEliminar(rowSelect.id, mensaje, url);
    } else {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5> <span>Solo los bines con estatus capturado y rechazado, pueden ser eliminados</span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }

  depurarBin(rowSelect: any){
    var mensaje = "¿Está seguro de eliminar el registro permanentemente, toda la información asociada será eliminada del sistema?";
    let modal: any = this.modalService.open(ModalsComponent, {
      modal_title: mensaje,
      modal_body: "",
      depurar: true,
    });
    modal.instance.onOkDepure.subscribe((depurar) => {
      if (depurar) {
        let scope = this;
        scope.blockBin.bin = rowSelect.bin;
        scope.blockBin.id = rowSelect.id;
        scope.blockBin.rol = localStorage.getItem("currentRol");
        scope.blockBin.procedencia = "depurarBin";
        if(rowSelect.isGrupo == 1) {
          scope.blockBin.idGrupo = rowSelect.idGrupo;
        }
        scope.zeroService.request({
          isSingleResponse: false,
          uri: REST_SERVICES.DEPURAR_BIN,
          method: "PUT",
          showInfo: true,
          params: scope.blockBin,
          ok: (response) => {
            if (response.responsecode == "0") {
              this.filtros = new ExecutorSearch();
              scope.toast.success(
                "<h5>Mensaje de sistema...</h5> <span>" + response.responseMessage + "</span>", "",
                { closeButton: false, enableHtml: true, disableTimeOut: false }
              );
              if (scope.page.pageNumber == -1) {
                scope.page.pageNumber = 0;
              }
              scope.buscarBin();
            }
          },
        });
      }
    });

  }

  modalComentarioEliminar(id: number, mensaje: string, url: string) {
    let modal: any = this.modalService.open(ModalsComponent, {
      modal_title: mensaje,
      modal_body: "",
      isComents: true,
    });
    modal.instance.onOkModalComment.subscribe((comentario) => {
      if (comentario) {
        this.eliminarSuspender(url, id, comentario);
      }
    });
  }

  bloqueoDesbloqueo(rowSelect: any, targetSelect: any) {
    let modal: any = this.modalService.open(ModalsComponent, {
      modal_title: targetSelect.checked
        ? "¿Está seguro de desbloquear el bin?"
        : "¿Está seguro de bloquear el bin?",
      modal_body: "",
      isComents: true,
    });
    modal.instance.onOkModalComment.subscribe((comentario) => {
      if (comentario) {
        let scope = this;
        let url = targetSelect.checked ? REST_SERVICES.DESBLOQUEO_BIN_SUPERVISOR : REST_SERVICES.BLOQUEO_BIN_SUPERVISOR;
        scope.blockBin.rol = localStorage.getItem("currentRol");
        scope.blockBin.comentarioOpe = comentario;
        scope.blockBin.id = rowSelect.id;
        scope.blockBin.procedencia = "bloqueoDesbloqueo";
        if(rowSelect.isGrupo == 1) {
          scope.blockBin.idGrupo = rowSelect.idGrupo;
        } else {
          scope.blockBin.idGrupo = null;
        }
        scope.zeroService.request({
          isSingleResponse: false,
          uri: url,
          method: "PUT",
          showInfo: true,
          params: scope.blockBin,
          ok: (response) => {
            if (response.responsecode == "0") {
              rowSelect.estatus = targetSelect.checked ? "ACTIVO" : "BLOQUEADO";
              // scope.toastService.show(
              //   '<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>',
              //   scope.globals.timeoutToast, 'blue');
              scope.toast.success("<h5>Mensaje de sistema...</h5> <span>" + response.responseMessage + "</span>", "",
                { closeButton: false, enableHtml: true, disableTimeOut: false }
              );
              if (scope.page.pageNumber == -1) {
                scope.page.pageNumber = 0;
              }
              scope.buscarBin();
            } else {
              targetSelect.checked = !targetSelect.checked;
            }
          },
          error: (response) => {
            targetSelect.checked = !targetSelect.checked;
          },
        });
      } else {
        targetSelect.checked = !targetSelect.checked;
      }
    });
  }

  eliminarSuspender(url: string, id: number, comentario: string) {
    let scope = this;
    scope.blockBin.id = id;
    scope.blockBin.rol = localStorage.getItem("currentRol");
    scope.blockBin.comentarioOpe = comentario;
    scope.blockBin.procedencia = "eliminarSuspender";
    if(this.isGrupo == 1) {
      scope.blockBin.idGrupo = id;
    } else {
      scope.blockBin.idGrupo = null;
    }
    scope.zeroService.request({
      isSingleResponse: false,
      uri: url,
      method: "PUT",
      showInfo: true,
      params: scope.blockBin,
      ok: (response) => {
        if (response.responsecode == "0") {
          this.filtros = new ExecutorSearch();
          scope.toast.success(
            "<h5>Mensaje de sistema...</h5> <span>" + response.responseMessage + "</span>", "",
            { closeButton: false, enableHtml: true, disableTimeOut: false }
          );
          if (scope.page.pageNumber == -1) {
            scope.page.pageNumber = 0;
          }
          scope.buscarBin();
        }
      },
    });
  }

  buscarBin() {
    let scope = this;
    this.grupoSelect = null;
    this.isGrupo = 0;
    if (!this.filtros.bin) {
      this.filtros.bin = null;
    }
    if (!this.filtros.idAccion) {
      this.filtros.idAccion = null;
    }
    if (!this.filtros.idBanco) {
      this.filtros.idBanco = null;
    }
    if (!this.filtros.idEstadoBin) {
      this.filtros.idEstadoBin = null;
    }
    if (!this.filtros.idTipoBin) {
      this.filtros.idTipoBin = null;
    }
    if (!this.filtros.fechaInicio) {
      this.filtros.fechaInicio = null;
    }
    if (!this.filtros.fechaFin) {
      this.filtros.fechaFin = null;
    }
    if (!this.filtros.tipoBin) {
      this.filtros.tipoBin = null;
    }
    this.filtros.idGrupo = null;
    this.filtros.paginaActual = this.page.pageNumber;
    this.filtros.origen = this.ruta;
    if (
      (undefined == this.filtros.fechaInicio &&
        undefined == this.filtros.fechaFin) ||
      this.filtros.fechaInicio <= this.filtros.fechaFin
    ) {
      scope.zeroService.request({
        isSingleResponse: false,
        uri: REST_SERVICES.BUSQUEDA_EJECUTOR,
        method: "POST",
        showInfo: true,
        params: scope.filtros,
        ok: (response) => {
          scope.rowsDataTables = new Array<BinesSeachResponse>();
          if (response.responsecode == "0") {
            scope.rowsDataTables = response.response;
            scope.rowsDataTables.forEach((x) => {
              x.fechaModOrigin = x.fechaMod;
              x.bloqueado = x.idEstatus != 2;
              x.fechaAlta = scope.datePipe.transform(x.fechaAlta, "dd/MM/yyyy", "UTC");
              x.fechaMod = scope.datePipe.transform(x.fechaMod, "dd/MM/yyyy", "UTC");
              x.userAlta = x.userAlta.includes("SISTEMA") ? x.userAlta : "";
              scope.page.totalElements = x.totalRegistros != null ? x.totalRegistros : 0;
            });
            scope.page.pageNumber = this.page.pageNumber - 1;
            scope.page.totalPages = this.page.totalElements / 6;
          } else {
            scope.page.pageNumber = 0;
            scope.page.totalPages = 0;
            scope.page.totalElements=0;
          }
        },
      });
    } else if (
      this.filtros.fechaInicio == undefined &&
      this.filtros.fechaFin != undefined
    ) {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Se requiere la fecha inicio<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else if (
      this.filtros.fechaInicio != undefined &&
      this.filtros.fechaFin == undefined
    ) {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Se requiere la fecha fin<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      scope.toast.warning(
        "<h5>Mensaje de sistema...</h5>La fecha inicio no puede ser mayor que la fecha fin <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }

  detalleGrupo(idGrupo:number) {
    let scope = this;
    this.grupoSelect = idGrupo;
    this.isGrupo = 1;
    this.filtros.bin = null;
    this.filtros.idAccion = null;
    this.filtros.idBanco = null;
    this.filtros.idEstadoBin = null;
    this.filtros.idTipoBin = null;
    this.filtros.fechaInicio = null;
    this.filtros.fechaFin = null;
    this.filtros.paginaActual = this.page.pageNumber;
    this.filtros.origen = this.ruta;
    this.filtros.idGrupo = idGrupo;
    this.filtros.tipoBin = "0";
    if (
      (undefined == this.filtros.fechaInicio &&
        undefined == this.filtros.fechaFin) ||
      this.filtros.fechaInicio <= this.filtros.fechaFin
    ) {
      scope.zeroService.request({
        isSingleResponse: false,
        uri: REST_SERVICES.BUSQUEDA_EJECUTOR,
        method: "POST",
        showInfo: true,
        params: scope.filtros,
        ok: (response) => {
          scope.rowsDataTables = new Array<BinesSeachResponse>();
          if (response.responsecode == "0") {
            scope.rowsDataTables = response.response;
            scope.rowsDataTables.forEach((x) => {
              x.fechaModOrigin = x.fechaMod;
              x.bloqueado = x.idEstatus != 2;
              x.fechaAlta = scope.datePipe.transform(x.fechaAlta, "dd/MM/yyyy", "UTC");
              x.fechaMod = scope.datePipe.transform(x.fechaMod, "dd/MM/yyyy", "UTC");
              x.userAlta = x.userAlta.includes("SISTEMA") ? x.userAlta : "";
              scope.page.totalElements = x.totalRegistros != null ? x.totalRegistros : 0;
            });
            scope.page.pageNumber = this.page.pageNumber - 1;
            scope.page.totalPages = this.page.totalElements / 6;
          } else {
            scope.page.pageNumber = 0;
            scope.page.totalPages = 0;
            scope.page.totalElements=0;
          }
        },
      });
    } else if (
      this.filtros.fechaInicio == undefined &&
      this.filtros.fechaFin != undefined
    ) {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Se requiere la fecha inicio<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else if (
      this.filtros.fechaInicio != undefined &&
      this.filtros.fechaFin == undefined
    ) {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Se requiere la fecha fin<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      scope.toast.warning(
        "<h5>Mensaje de sistema...</h5>La fecha inicio no puede ser mayor que la fecha fin <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }

  buscarInstituciones() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_INSTITUCIONES.replace("%id", "0"),
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.institucion = response.response;
        }
      },
    });
  }

  buscarTipoBin() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_TIPO_BIN,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.tipoBin = response.response;
        }
      },
    });
  }

  buscarTipoBinReporte() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_TIPO_BIN,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.tipoBinReportes = response.response
          .filter(item => item.id == 1 || item.id == 3 || item.id == 4 || item.id == 2)
          .map(item => {
            // Mapear nombres personalizados
            const nombresPersonalizados: { [key: number]: string } = {
              1: item.descripcion,
              2: 'BINES ESPECIALES',
              3: item.descripcion,
              4: 'BINES LATAM'
            };
            return {
              ...item,
              descripcion: nombresPersonalizados[item.id] || item.descripcion
            };
          });
        }
      },
    });
  }

  private buscarTipoBinesLatam() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_TIPO_BIN,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.tipoBinesLatam = response.response.filter(item => 
            item.id == 7 || item.id == 9 || item.id == 12 || item.id == 5 || item.id == 8
          );
        }
      },
    });
  }

  private buscarTipoBinesEspeciales() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_TIPO_BIN,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.tipoBinesEspeciales = response.response.filter(item => 
            item.id == 1
          );
        }
      },
    });
  }

  onTipoBinChange() {
    if (this.filtrosRep.idTipoBin == 4) {
      this.filtrosRep.idTipoBinEspecial = null;
      this.filtrosRep.idMarca = null;
    } else if (this.filtrosRep.idTipoBin == 1) {
      this.filtrosRep.idTipoBinLatam = null;
      this.filtrosRep.idTipoBinEspecial = null;
    } else if (this.filtrosRep.idTipoBin == 2) {
      this.filtrosRep.idTipoBinLatam = null;
      this.filtrosRep.idMarca = null;
    } else {
      this.filtrosRep.idTipoBinLatam = null;
      this.filtrosRep.idTipoBinEspecial = null;
      this.filtrosRep.idMarca = null;
    }
  }

  isMarcaHabilitada(): boolean {
    return (this.filtrosRep.idTipoBin == 1 || this.filtrosRep.idTipoBin == 4) && this.filtrosRep.idEstadoBin != 6;
  }

  getMarcasReportes(): Array<CatalogoModel> {
    if (this.filtrosRep.idTipoBin == 4) {
      return this.marca.filter(item => item.id == 1 || item.id == 2 || item.id == 7);
    }

    return this.marca;
  }

  buscarEstatus() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_ESTATUS,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.estatus = response.response;
        }
      },
    });
  }

  buscarAccion() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_ACCION,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          if (scope.checkBin) {
            response.response.forEach((element) => {
              if (element.id == 1 || element.id == 3 || element.id == 4 || element.id == 7) {
                scope.accion.push(element);
              }
            });
          } else {
            scope.accion = response.response;
          }
        }
      },
    });
  }

  validarNumberBin(e: KeyboardEvent, valor: number) {
    if (
      e.keyCode < 48 ||
      e.keyCode > 57 ||
      (valor && valor.toString().length > 5)
    ) {
      return false;
    }
  }

  // Validador de fechas para indicado de semaforo
  checksemaforo(row): String {
    let classes = "";
    // Solo Valido en bines bloqueados
    if (row["idEstatus"] !== 2) {
      return classes;
    }

    // calculo de difencias de dias
    var date1 = new Date(row.fechaModOrigin);
    var date2 = new Date(); //less than 1
    var start = Math.floor(date1.getTime() / (3600 * 24 * 1000)); //days as integer from..
    var end = Math.floor(date2.getTime() / (3600 * 24 * 1000)); //days as integer from..
    var daysDiff = end - start; // exact dates

    // asignacion de semaforo
    if (daysDiff > 3) {
      classes = "semaforo_red";
    } else if (daysDiff === 3) {
      classes = "semaforo_yellow";
    } else if (daysDiff === 2 || daysDiff < 2) {
      classes = "semaforo_green";
    }

    return classes;
  }

  // REPORTES
  /**
   *  Limpia campos para reportes.
   */
  limpiarReportes() {
    this.filtrosRep = new ReporteRequest();
  }

  /**
   * Metodo que ejecuta la consulta del reporte y descarga de archivo.
   */


  exportarExcel() {
    let scope = this;
    console.log('Datos enviados:', this.filtrosRep);
    if (!this.filtrosRep.idTipoBin) {
      this.filtrosRep.idTipoBin = null;
    }
    if (!this.filtrosRep.idTipoBinLatam) {
      this.filtrosRep.idTipoBinLatam = null;
    }
    if (!this.filtrosRep.idTipoBinEspecial) {
      this.filtrosRep.idTipoBinEspecial = null;
    }
    if (!this.filtrosRep.idInstitucion) {
      this.filtrosRep.idInstitucion = null;
    }
    if (!this.filtrosRep.idEstadoBin) {
      this.filtrosRep.idEstadoBin = null;
    }
    if (!this.filtrosRep.idMarca) {
      this.filtrosRep.idMarca = null;
    }
    if (!this.filtrosRep.fechaInicio) {
      this.filtrosRep.fechaInicio = null;
    }
    if (!this.filtrosRep.fechaFin) {
      this.filtrosRep.fechaFin = null;
    }
    var dateInicio = this.filtrosRep.fechaInicio != undefined ? new Date(this.filtrosRep.fechaInicio) : undefined;
    var dateFin = this.filtrosRep.fechaFin != undefined ? new Date(this.filtrosRep.fechaFin) : undefined;

if (this.filtrosRep.idEstadoBin == 6) {
  this.reporteEliminados();
} else {

    if ((undefined == dateInicio && undefined == dateFin) || dateInicio <= dateFin) {
      switch (+this.filtrosRep.idTipoBin) {
        case 1: {
          this.reporteEmisorNacionaRequest();
          break;
        }
        case 2: {
          this.reporteEmisorEglobal();
          break;
        }
        case 3: {
          this.reporteAdquirenteNacionalRequest();
          break;
        }
        case 4: {
          this.reporteemisorInternacional();
          break;
        }
        default: {
          break;
        }
      }
    } else if (
      this.filtrosRep.fechaInicio == undefined &&
      this.filtrosRep.fechaFin != undefined
    ) {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Se requiere la fecha inicio<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else if (
      this.filtrosRep.fechaInicio != undefined &&
      this.filtrosRep.fechaFin == undefined
    ) {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Se requiere la fecha fin<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      scope.toast.warning(
        "<h5>Mensaje de sistema...</h5>La fecha inicio no puede ser mayor que la fecha fin <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }
  }
  /**
   * Metodo que  lanza la cosulta para obtener información del reporte de Emisor Nacional
   */
  reporteEmisorNacionaRequest() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_EMISOR_NACIONAL,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtrosRep,
      ok: (response) => {
        this.procesaResponse(response);
        //this.descargaArcvhivo(response);
      },
    });
  }

  /**
   * Metodo que  lanza la cosulta para obtener información del reporte de Emisor Eglobal
   */
  reporteEmisorEglobal() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_EMISOR_ESPECIAL,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtrosRep,
      ok: (response) => {
        this.procesaResponse(response);
        //this.descargaArcvhivo(response);
      },
    });
  }
  /**
   * Metodo que  lanza la cosulta para obtener información del reporte de Adquirente Nacional
   */
  reporteAdquirenteNacionalRequest() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_ADQUIRENTE_NACIONAL,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtrosRep,
      ok: (response) => {
        this.procesaResponse(response);
        //this.descargaArcvhivo(response);
      },
    });
  }
  /**
   * Metodo que  lanza la cosulta para obtener información del reporte de Emisor internacional
   */
  private reporteemisorInternacional() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_EMISOR_INTERNACIONAL,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtrosRep,
      ok: (response) => {
        this.procesaResponse(response);
        //this.descargaArcvhivo(response);
      },
    });
  }

  /**
   * Metodo que lanza la petición para obtener información del catálogo de marca de productos.
   */
  private buscarMarcaProducto() {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.CATALOGO_MARCA,
      method: "GET",
      showInfo: true,
      isSingleResponse: false,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.marca = response.response;
        }
      },
    });
  }


  /**
   * Metodo que  lanza la cosulta para obtener información del reporte de bines eliminados historicos
   */
  reporteEliminados(){
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_ELIMINADOS_HISTORICO,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtrosRep,
      ok: (response) => {
        this.procesaResponse(response);
        //this.descargaArcvhivo(response);
      },
    });
  }

  private procesaResponse(response) {
    if (response.response.archivoReporte != null) {
      this.toast.success(
        "<h5>Mensaje de sistema...</h5>El reporte " + `${response.response.nombre}`+", se estará generando y se notificara cuando este disponible para su descarga. <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Error al generar el reporte de bines<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }

  /**
   * Método que descarga el archivo recibido en la respuesta del microservicio
   * @param response    response obtenido de la respuesta del microservicio.
   */
  private descargaArcvhivo(response) {
    if (response.response.archivoReporte != null) {
      let base64data = this.base64ToBlob(response.response.archivoReporte);
      let blob = new Blob([base64data], { type: "text/csv;charset=utf-8;" });
      FileSaver.saveAs(blob, response.response.nombre);
      this.toast.success(
        "<h5>Mensaje de sistema...</h5>El reporte " + `${response.response.nombre}`+", se ha generado y descargado exitosamente <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Error al generar el reporte de bines<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }

  /**
   * Metodo que retorna un blob el archivo recibido en base64
   * @param b64Data     Cadena en base64
   * @param sliceSize
   */
  public base64ToBlob(b64Data, sliceSize = 512) {
    const byteCharacters = atob(b64Data); //data.file there
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
      type: "apadsheetml.sheet",
    });
  }

  buscarBinElim() {
    let scope = this;
    this.grupoSelect = null;
    this.isGrupo = 0;
    if (!this.filtros.bin) {
      this.filtros.bin = null;
    }
    if (!this.filtros.idAccion) {
      this.filtros.idAccion = null;
    }
    if (!this.filtros.idBanco) {
      this.filtros.idBanco = null;
    }
    if (!this.filtros.idEstadoBin) {
      this.filtros.idEstadoBin = null;
    }
    if (!this.filtros.idTipoBin) {
      this.filtros.idTipoBin = null;
    }
    if (!this.filtros.fechaInicio) {
      this.filtros.fechaInicio = null;
    }
    if (!this.filtros.fechaFin) {
      this.filtros.fechaFin = null;
    }
    if (!this.filtros.tipoBin) {
      this.filtros.tipoBin = null;
    }
    this.filtros.idGrupo = null;
    this.filtros.paginaActual = this.page.pageNumber;
    this.filtros.origen = this.ruta;
    if (
      (undefined == this.filtros.fechaInicio &&
        undefined == this.filtros.fechaFin) ||
      this.filtros.fechaInicio <= this.filtros.fechaFin
    ) {
      scope.zeroService.request({
        isSingleResponse: false,
        uri: REST_SERVICES.BUSQUEDA_EJECUTOR,
        method: "POST",
        showInfo: true,
        params: scope.filtros,
        ok: (response) => {
          scope.rowsDataTablesElim = new Array<BinesSeachElimResponse>();
          if (response.responsecode == "0") {
            scope.rowsDataTablesElim = response.response;
            scope.rowsDataTablesElim.forEach((x) => {
              x.fch_alta = scope.datePipe.transform(x.fch_alta, "dd/MM/yyyy", "UTC");
              x.fch_autorizacion = scope.datePipe.transform(x.fch_autorizacion, "dd/MM/yyyy", "UTC");
              x.fch_mod = scope.datePipe.transform(x.fch_mod, "dd/MM/yyyy", "UTC");
              scope.page.totalElements = x.totalRegistros != null ? x.totalRegistros : 0;
            });
            scope.page.pageNumber = this.page.pageNumber - 1;
            scope.page.totalPages = this.page.totalElements / 6;
          } else {
            scope.page.pageNumber = 0;
            scope.page.totalPages = 0;
            scope.page.totalElements=0;
          }
        },
      });
    }
  }

  buscarBinCifrasControl() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CIFRAS_CONTROL_BINESALTA_PENDIENTES,
      method: "POST",
      showInfo: true,
      ok: (response) => {
        if (response.responseCode.code == "IGBL000") {
          scope.control = response.response;
          if (scope.control.binesPendientes.length > 0) {
            this.enableExportar = true;
            this.convertDatasetPieChart(scope.control.binesPendientes);
          }
        }
      },
    });
  }

	
 /**
   * Metodo que ejecuta la consulta del reporte de bines pendientes.
   */

  exportarExcelBines() {
    this.reportePendientesAlta();
  }

  private reportePendientesAlta() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_BINESALTA_PENDIENTES,
      method: "POST",
      showInfo: true,
      showLoading: true,
      ok: (response) => {
        console.log(response);
        this.procesaResponse(response);
      },
    });
  }

}